export default __webpack_public_path__ + "maps-guides-styles-layers-raster-layer-960-f93e70e122085711bbd278593d46427a.webp";